var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLazyQuery, useShowFlag } from "@atlassiansox/microscopekit";
import { capitalizeWord, getInstances, getServiceId, sshProxyUrls, } from "../utils";
import serviceInstancesQuery from "./service-instances.query.graphql";
var AkButton = require("@atlaskit/button").default;
var AkSelect = require("@atlaskit/select").default;
var SSHDropdownContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 32px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  margin-top: 32px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
export var AkSelectContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: 8px;\n  width: 100%;\n"], ["\n  margin-right: 8px;\n  width: 100%;\n"])));
export var SSHDropdown = function (_a) {
    var deploymentId = _a.deploymentId, env = _a.env, deploymentType = _a.deploymentType;
    var _b = useState(null), selected = _b[0], setSelected = _b[1];
    var showFlag = useShowFlag();
    var _c = useLazyQuery(serviceInstancesQuery, { errorPolicy: "all" }), getServiceInstances = _c[0], _d = _c[1], loading = _d.loading, error = _d.error, data = _d.data;
    useEffect(function () {
        if (error) {
            showFlag({
                title: "Error",
                message: "There was an error retrieving service instances.",
                type: "error",
            });
        }
    }, [error]);
    var serviceId = getServiceId(deploymentId);
    var instances = data
        ? getInstances(data, deploymentId, deploymentType)
        : [];
    var getGroupType = function (groupName) {
        try {
            var groupNameParts = groupName.split("--");
            return capitalizeWord(groupNameParts[groupNameParts.length - 1]);
        }
        catch (e) {
            throw new Error("Failed to get group type from MicrosScalingGroup.groupName: " + groupName + ". " + e);
        }
    };
    var instanceIdOptions = Array.from(instances.map(function (instance) { return ({
        label: getGroupType(instance.groupName) + ": " + instance.id,
        value: instance.id,
    }); }));
    var sshIntoInstance = function () {
        if (!selected) {
            return;
        }
        var instanceId = selected.value;
        var baseURL = sshProxyUrls.get(env);
        var sshURL = "https://" + baseURL + "/app/assume/" + encodeURIComponent(serviceId) + "/session/" + encodeURIComponent(instanceId) + "?env=" + env;
        window.open(sshURL, "_blank");
    };
    var loadServiceInstances = function () {
        if (loading || instances.length > 0) {
            // Load once.
            return;
        }
        getServiceInstances({ variables: { id: serviceId } });
    };
    return (React.createElement(SSHDropdownContainer, null,
        React.createElement(AkSelectContainer, { onClick: loadServiceInstances },
            React.createElement(AkSelect, { isLoading: loading, options: instanceIdOptions, value: selected, onChange: function (value) { return setSelected(value); }, placeholder: "Instance" })),
        React.createElement(AkButton, { onClick: sshIntoInstance, isDisabled: loading || !selected }, "SSH Into Instance")));
};
var templateObject_1, templateObject_2;
